import { useEffect } from "react";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Cursor from "@/components/Cursor";
import Header from "@/components/Header";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import WhyUs from "@/components/sections/WhyUs";
import Services from "@/components/sections/Services";
import Impact from "@/components/sections/Impact";
import Coverage from "@/components/sections/Coverage";
import Projects from "@/components/sections/Projects";
import Leadership from "@/components/sections/Leadership";
import Team from "@/components/sections/Team";
import Testimonials from "@/components/sections/Testimonials";
import Clients from "@/components/sections/Clients";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import PhotoDivider from "@/components/PhotoDivider";
import ServicePage from "@/pages/ServicePage";
import AdminPage from "@/pages/AdminPage";
import { LanguageProvider } from "@/i18n/LanguageContext";

const Home = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    }, 250);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main>
      <Hero />
      <About />
      <WhyUs />
      <Services />
      <Leadership />
      <Team />
      <Projects />
      <PhotoDivider />
      <Testimonials />
      <Clients />
      <Impact />
      <Coverage />
      <Contact />
    </main>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      smoothWheel: true,
      anchors: { offset: -72 },
    });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <LanguageProvider>
        <BrowserRouter>
        <div id="top" className="bg-[#050505] font-manrope text-white antialiased">
          <div className="grain-overlay" aria-hidden="true" />
          <Cursor />
          <Header />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="bottom-right" />
        </div>
        </BrowserRouter>
      </LanguageProvider>
    </MotionConfig>
  );
}
